const video = require('./shared/test.mp4')
const pins = require('./shared/pins.png')
const buildings = require('./shared/buildings.png')
const building1 = require('./shared/building1.png')
const building2 = require('./shared/building2.png')
const building3 = require('./shared/building3.png')
const building4 = require('./shared/building4.png')
const building5 = require('./shared/building5.png')
const building6 = require('./shared/building6.png')
const buildingsIOT = require('./shared/buildingsIOT.png')
const buildingsWIRELESS = require('./shared/buildingsWIRELESS.png')
const buildingsWIRED = require('./shared/buildingsWIRED.png')
const buttonIOT = require('./shared/buttonIOT.png')
const buttonWIRELESS = require('./shared/buttonWIRELESS.jpg')
const buttonWIRED = require('./shared/buttonWIRED.jpg')
const close = require('./shared/close.png')
const detailWIRELESS = require(`./shared/detailWIRELESS.png`)

export default lang => {
  console.log('Loading assets for', lang)
  return {
    images: {
      // Static assets
      pins,
      buildings,
      building1,
      building2,
      building3,
      building4,
      building5,
      building6,
      buildingsIOT,
      buildingsWIRELESS,
      buildingsWIRED,
      buttonIOT,
      buttonWIRELESS,
      buttonWIRED,
      close,
      detailWIRELESS,

      // Localized assets
      detailIOT: require(`./${lang}/detailIOT.png`),
      detailWIRED: require(`./${lang}/detailWIRED.png`),
      hydrocal: require(`./${lang}/hydrocal.png`),
      hydroclima: require(`./${lang}/hydroclima.png`),
      hydrosplit: require(`./${lang}/hydrosplit.png`),
      gmdm: require(`./${lang}/gmdm.png`),
      gsd8: require(`./${lang}/gsd8.png`),
      k50: require(`./${lang}/k50.png`)
    },
    others: { video }
  }
}



// WEBPACK FOOTER //
// ./src/Assets/index.js